import { bianka } from '@fiverr-private/obs';
import { getContext } from '@fiverr-private/fiverr_context';
import { Click, ClickType, ElementType } from '@fiverr-private/bianka_js';
import { ClickedBriefStatusChangeAction } from '@fiverr-private/bianka_js/protobuf/bianka/event/activity/v2/extension/dynamic_matches/clicked_brief_status_change_action';

interface BriefStatusChangeClickActionProps {
    briefId: string;
    statusChosen: string;
    clickedOn: 'yes' | 'no';
    reason?: string;
    eventSource: string;
}

/**
 * Event for clicking on the section actions: add, delete, save
 *
 * @param BriefEditSectionClickActionProps
 */
export const briefStatusChangeClickAction = ({
    briefId,
    clickedOn,
    reason,
    statusChosen,
    eventSource,
}: BriefStatusChangeClickActionProps) => {
    bianka.reportActivity({
        type: Click,
        event: {
            type: 'clicked_brief_status_change',
            clickType: ClickType.LEFT,
            element: {
                name: clickedOn,
                type: ElementType.BUTTON,
                text: { value: statusChosen },
            },
            organization: { id: getContext().organizationId || '' },
        },
        additionalData: {
            type: ClickedBriefStatusChangeAction,
            message: {
                briefId,
                reason,
                eventSource,
            },
        },
    });
};
